/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CentreNotificationResponse } from '../../models/centre-notification-response';

export interface GetNotificationNonSupprimeesByIntervenant$Params {
  id_intervenant: string;
}

export function getNotificationNonSupprimeesByIntervenant(
  http: HttpClient,
  rootUrl: string,
  params: GetNotificationNonSupprimeesByIntervenant$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<CentreNotificationResponse>> {
  const rb = new RequestBuilder(rootUrl, getNotificationNonSupprimeesByIntervenant.PATH, 'get');
  if (params) {
    rb.path('id_intervenant', params.id_intervenant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CentreNotificationResponse>;
    })
  );
}

getNotificationNonSupprimeesByIntervenant.PATH =
  '/v1/centre-notification/{id_intervenant}/notifications-non-supprimees';
